module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home-content-page-v"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "1rem",
      "display": "flex"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "配送中心"
    },
    model: {
      value: (_vm.car_center),
      callback: function($$v) {
        _vm.car_center = $$v
      },
      expression: "car_center"
    }
  }, _vm._l((_vm.pszxDatas), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "车轴筛选"
    },
    model: {
      value: (_vm.axle_key),
      callback: function($$v) {
        _vm.axle_key = $$v
      },
      expression: "axle_key"
    }
  }, _vm._l((_vm.AXLE_LIST), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  })), _vm._v(" "), _c('div', [_c('el-input', {
    attrs: {
      "placeholder": "请输入车牌号"
    },
    model: {
      value: (_vm.s_car_id),
      callback: function($$v) {
        _vm.s_car_id = $$v
      },
      expression: "s_car_id"
    }
  })], 1), _vm._v(" "), (_vm.showQiandao) ? _c('div', {
    staticClass: "file-input"
  }, [_c('span', {
    staticStyle: {
      "color": "#777",
      "font-size": "1rem",
      "margin-right": "1rem"
    }
  }, [_vm._v("导入签到")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "file-4"
    },
    on: {
      "change": _vm.qdFileChange
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('content-title', {
    attrs: {
      "title": "车辆管理",
      "actions": _vm.titleAction
    },
    on: {
      "clickMenu": _vm.clickTitleMenu
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "output-content"
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.searchCar(),
      "table_actions": _vm.table_actions,
      "table_style": 2,
      "ths": _vm.ths,
      "show_checkbox": _vm.showQiandao
    },
    on: {
      "clickTdBtn": _vm.clickTdBtn
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.isNew ? '新增车辆' : '修改车辆',
      "visible": _vm.showAdd
    },
    on: {
      "update:visible": function($event) {
        _vm.showAdd = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("车牌号")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "disabled": !_vm.isNew,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['车牌号']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '车牌号', $$v)
      },
      expression: "carMap['车牌号']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("配送中心")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['配送中心']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '配送中心', $$v)
      },
      expression: "carMap['配送中心']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("承运商")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['承运商']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '承运商', $$v)
      },
      expression: "carMap['承运商']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("牵引车")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['牵引车']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '牵引车', $$v)
      },
      expression: "carMap['牵引车']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("车辆轴数")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.carMap['车辆轴数']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '车辆轴数', $$v)
      },
      expression: "carMap['车辆轴数']"
    }
  }, _vm._l((_vm.AXLE_LIST.slice(0, -1)), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("停车点")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.carMap['停车油库代码']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '停车油库代码', $$v)
      },
      expression: "carMap['停车油库代码']"
    }
  }, _vm._l((_vm.depotList), function(item) {
    return _c('el-option', {
      key: item['油库代码'],
      attrs: {
        "label": item['油库名称'],
        "value": item['油库代码']
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("驾驶员")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.carMap['司机']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '司机', $$v)
      },
      expression: "carMap['司机']"
    }
  }, _vm._l((_vm.driver_list), function(item, index) {
    return _c('el-option', {
      key: item['姓名'] + index,
      attrs: {
        "label": item['姓名'],
        "value": item['姓名']
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("道路运输证准运油品")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.carMap['道路运输证准运油品']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '道路运输证准运油品', $$v)
      },
      expression: "carMap['道路运输证准运油品']"
    }
  }, _vm._l((['汽油', '柴油']), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("电子运单装载油品")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.carMap['电子运单装载油品']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '电子运单装载油品', $$v)
      },
      expression: "carMap['电子运单装载油品']"
    }
  }, _vm._l((['汽油', '柴油']), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("合计")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['合计']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '合计', $$v)
      },
      expression: "carMap['合计']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("前仓")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['前仓']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '前仓', $$v)
      },
      expression: "carMap['前仓']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("中仓")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['中仓']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '中仓', $$v)
      },
      expression: "carMap['中仓']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("后仓")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.carMap['后仓']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '后仓', $$v)
      },
      expression: "carMap['后仓']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("通行证")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.carMap['通行证']),
      callback: function($$v) {
        _vm.$set(_vm.carMap, '通行证', $$v)
      },
      expression: "carMap['通行证']"
    }
  }, _vm._l((_vm.PASS_LIST), function(item) {
    return _c('el-option', {
      key: item.key,
      attrs: {
        "label": item.label,
        "value": item.key
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showAdd = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveCar
    }
  }, [_vm._v("保 存")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "油品变更",
      "visible": _vm.showChange
    },
    on: {
      "update:visible": function($event) {
        _vm.showChange = $event
      }
    }
  }, [(Number(_vm.carMap['更改油品']) === 1) ? _c('div', {
    staticClass: "case-form"
  }, [_c('span', [_vm._v("油品已变更，变更信息如下")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "case-form"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("车牌号")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "disabled": !_vm.isNew,
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.changeOil['车牌号']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '车牌号', $$v)
      },
      expression: "changeOil['车牌号']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("更改油品")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "请选择",
      "size": "small"
    },
    model: {
      value: (_vm.changeOil['更改油品']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '更改油品', $$v)
      },
      expression: "changeOil['更改油品']"
    }
  }, _vm._l((['汽油', '柴油']), function(item) {
    return _c('el-option', {
      key: item,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("实际油品容积和")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.changeOil['实际油品容积和']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '实际油品容积和', $$v)
      },
      expression: "changeOil['实际油品容积和']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("前仓")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.changeOil['前仓']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '前仓', $$v)
      },
      expression: "changeOil['前仓']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("中仓")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.changeOil['中仓']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '中仓', $$v)
      },
      expression: "changeOil['中仓']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("后仓")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.changeOil['后仓']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '后仓', $$v)
      },
      expression: "changeOil['后仓']"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("品名变更记录")]), _vm._v(" "), _c('el-input', {
    attrs: {
      "size": "small",
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.changeOil['品名变更记录']),
      callback: function($$v) {
        _vm.$set(_vm.changeOil, '品名变更记录', $$v)
      },
      expression: "changeOil['品名变更记录']"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showChange = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), (Number(_vm.carMap['更改油品']) === 1) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delChangeCarOilType
    }
  }, [_vm._v("取消变更")]) : _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setCarOilType
    }
  }, [_vm._v("确定变更")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.carMap['车牌号'] + ' >>> 限制可配送油站',
      "visible": _vm.showGasXz
    },
    on: {
      "update:visible": function($event) {
        _vm.showGasXz = $event
      }
    }
  }, [_c('div', {
    staticClass: "case-form xz-gas"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("可配送油站")]), _vm._v(" "), _c('div', {
    staticClass: "gas-list"
  }, [(!_vm.xzGasList || _vm.xzGasList.length === 0) ? _c('strong', [_vm._v("没有可配送油站限制")]) : _vm._l((_vm.xzGasList), function(data) {
    return _c('span', [_vm._v(_vm._s(data['加油站名称'])), _c('i', {
      staticClass: "icon-105 iconfont",
      on: {
        "click": function($event) {
          _vm.delXzGas(data)
        }
      }
    })])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "case-form"
  }, [_c('div', {
    staticClass: "one-input"
  }, [_c('span', [_vm._v("添加油站")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "filterable": "",
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.selectGas),
      callback: function($$v) {
        _vm.selectGas = $$v
      },
      expression: "selectGas"
    }
  }, _vm._l((_vm.gasList), function(item) {
    return _c('el-option', {
      key: item['油站代码'],
      attrs: {
        "label": item['加油站名称'],
        "value": item
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('div', {
    staticClass: "case-form",
    staticStyle: {
      "color": "#888",
      "font-size": "1rem"
    }
  }, [_c('span', [_vm._v("添加可配送油站后，该车辆只能配送指定加油站。")])]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showGasXz = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.setGasXz
    }
  }, [_vm._v("保存限制")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.showDel,
      "size": "tiny"
    },
    on: {
      "update:visible": function($event) {
        _vm.showDel = $event
      }
    }
  }, [_c('span', [_vm._v("你确定删除该车辆吗？")]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDel = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.delCar
    }
  }, [_vm._v("确 定")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.showCheckData,
      "size": "large"
    },
    on: {
      "update:visible": function($event) {
        _vm.showCheckData = $event
      }
    }
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingWarning),
      expression: "loadingWarning"
    }]
  }, [(_vm.warningDataWqd.length > 0) ? _c('content-title', {
    attrs: {
      "title": "未签到异常车辆"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.warningDataWqd.length > 0) ? _c('div', {
    staticClass: "output-content"
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.warningDataWqd,
      "table_style": 2,
      "ths": _vm.thsW
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.warningDataQd.length > 0) ? _c('content-title', {
    attrs: {
      "title": "已签到异常车辆"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.warningDataQd.length > 0) ? _c('div', {
    staticClass: "output-content"
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.warningDataQd,
      "table_style": 2,
      "ths": _vm.thsW
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showCheckData = false
      }
    }
  }, [_vm._v("取 消")])], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "提示",
      "visible": _vm.showQdError
    },
    on: {
      "update:visible": function($event) {
        _vm.showQdError = $event
      }
    }
  }, [_c('div', [_c('content-title', {
    attrs: {
      "title": "导入文件签到异常数据"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "output-content"
  }, [_c('mii-base-table', {
    attrs: {
      "datas": _vm.errorData,
      "table_style": 2,
      "ths": _vm.thsE
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showQdError = false
      }
    }
  }, [_vm._v("取 消")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69a7bbad","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/oil/car.vue
// module id = 994
// module chunks = 1